"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.elevation = exports.onlyForLargeScreen = exports.onlyForMobile = exports.onlyForDesktop = exports.device = exports.colors = exports.fonts = void 0;
var styled_components_1 = require("styled-components");
var colors = {
    darkblue: '#1a4794',
    deepBlue: '#233977',
    blue: '#1156B2',
    greyBlue: '#008CD2',
    green: '#63d1b5',
    purple: '#D9C3FF',
    orange: '#FFE0B3',
    greenLight: '#bbe8cd',
    greenLight2: '#76D19B',
    lightBlue: '#edf2fa',
    lightThinBlue: '#cce8f6',
    lightGrey: '#e9e9e9',
    lightBlue3: '#F5F8FB',
    grey: '#787878',
    black: '#232323',
    white: '#ffffff',
    error: '#fe3222',
    red: '#FE3123',
    yellowLight: '#FFE0B3',
    waterBlue: '#CCE8F7',
    E2G_green: '#95c11e',
    E2G_greenLight: '#aadb23',
    ESVDL_lightBlue: '#91C8E5',
    ESVDL_deepBlue: '#295A75',
    EDM_blue: '#0B71B4',
    EDM_lightBlue: '#68AFDC',
    SIAEP_blue: '#1582B0',
    SIAEP_lightBlue: '#39A5D7',
    SIAEP_yellow: '#D7B731',
    SIAEP_green: '#A7BC16',
    SIAEP_greenLight: '#a7bc16b3',
    SEPRA_DeepBlue: '#415986',
    SEPRA_blue: '#6081be',
    SEPRA_lightBlue: '#8ebebc',
    SEPRA_green: '#90b65d',
    SEPRA_greenLight: '#90b65db3',
    SEM_blue: '#004670',
    SEM_lightBlue: '#4CA4DE',
    SEM_green: '#82A938',
    SEM_greenLight: '#a7bc16b3',
    SEM_HighlightBlue: '#1057B2',
    SIECCAO_DeepBlue: '#243977',
    SIECCAO_blue: '#1156B2',
    SIECCAO_lightBlue: '#008CD2',
    SIECCAO_green: '#63D1B4',
    SIECCAO_greenLight: '#63D1B4b3',
    ILEO_red: '#e30613',
    SBAA_blue: '#2A2B81',
    SBAA_lightBlue: '#1570B6',
    SBAA_green: '#93BF1A',
    SBAA_lightGreen: '#63D1B4',
    GMVA_dark_green: '#003746',
    GMVA_deep_green: '#01A29C',
    GMVA_light_green: '#63D1B4',
    GMVA_yellow_green: '#A1C517',
    MARTINIQUE_BLUE: '#003b5b',
    MARTINIQUE_GREEN: '#01b1a9',
    GPEAU_BLUE: '#18bbee',
    GPEAU_GREEN: '#00a796',
    GPEAU_ORANGE: '#f39328',
    GPEAU_LIGHT_ORANGE: '#fbcf9f',
    VILIVIA_YELLOW: '#d7dc52',
    VILIVIA_DARK_YELLOW: '#afc81e',
    VILIVIA_GREEN: '#58ae31',
    VILIVIA_YELLOW_LIGHT: '#e0e55d',
    VILIVIA_GREEN_LIGHT: '#76c254',
    VILIVIA_GREEN_DARK: '#3f9e2f',
    VILIVIA_DARK_YELLOW_DARK: '#8fa518',
    VILIVIA_GREY: '#4d4d4d',
    VILIVIA_GREY_LIGHT: '#e0e0e0'
};
exports.colors = colors;
var elevation = {
    high: {
        top: 210,
        default: 200,
        under: 190
    },
    sup: {
        top: 110,
        default: 100,
        under: 90
    },
    base: {
        top: 10,
        default: 0,
        under: -10
    }
};
exports.elevation = elevation;
var breakpoints = {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px'
};
var device = {
    mobile: "(min-width: " + breakpoints.mobile + ")",
    tablet: "(min-width: " + breakpoints.tablet + ")",
    desktop: "(min-width: " + breakpoints.desktop + ")"
};
exports.device = device;
var fonts = {
    montserratSemiBoldName: 'montserrat-semibold',
    montserratBoldName: 'montserrat-bold',
    montserratBlackName: 'montserrat-black',
    montserratItalicName: 'montserrat-italic',
    montserratRegularName: 'montserrat-regular',
    montserratMediumName: 'montserrat-medium'
};
exports.fonts = fonts;
var onlyForDesktop = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: flex;\n  }\n"], ["\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: flex;\n  }\n"])), device.mobile, device.tablet);
exports.onlyForDesktop = onlyForDesktop;
var onlyForMobile = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media ", " {\n    display: flex;\n  }\n  @media ", " {\n    display: none;\n  }\n"], ["\n  @media ", " {\n    display: flex;\n  }\n  @media ", " {\n    display: none;\n  }\n"])), device.mobile, device.tablet);
exports.onlyForMobile = onlyForMobile;
var onlyForLargeScreen = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: flex;\n  }\n"], ["\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: none;\n  }\n  @media ", " {\n    display: flex;\n  }\n"])), device.mobile, device.tablet, device.desktop);
exports.onlyForLargeScreen = onlyForLargeScreen;
var templateObject_1, templateObject_2, templateObject_3;
